import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const devConfig: ApplicationConfig = {
  apiUrl: 'https://dev-api.skin-seoul.com',
  csAgentApiUrl: 'https://dev-agent.skin-seoul.com',
  internalApiUrl: 'https://dev.internal-api.skin-seoul.work',
  googleOAuthClientId: '639007308170-lcrsao9lgj3km159oo6uj2sjhs8tbrb8.apps.googleusercontent.com',
  apiKey: '75dd554a-2b38-4774-807d-a3d1a870c9e7',
  stage: Stage.DEV,
  sheetId: '1CNmHugwnAfmcFjMf1okeUJBsoUtFh7o-ktd7qXrcyEU',
  wpAdminUrl: 'https://dev.skin-seoul.com/wp-admin/',
  adminUrl: 'https://dev.admin.skin-seoul.work',
  n8nWebhookBaseUrl: 'https://dev-n8n.skin-seoul.work',
  slackTeamId: 'T06CKAJHMRU',
  logtoEndpoint: 'https://dev-auth.skin-seoul.com',
  logtoAppId: '9k0wksyunhb1wpkkppc5s',
  logtoStaffOrganizationId: 'qbhhenj8k9z0',
};
